import { FC } from 'react';
import s from './index.module.scss';
import classNames from 'classnames';
import WarningIcon from 'assets/img/svg/warning-circle-svgrepo-com.svg';

interface Props {
	message?: string;
	className?: string;
}

const Notice: FC<Props> = props => {
	return (
		<span className={classNames(s.notice, props.className)}>
			<img className={s.icon} src={WarningIcon} width={20} height={20} />
			{props?.message?.length && <span className={s.text}>{props.message}</span>}
		</span>
	);
};

export default Notice;
